import axios from 'axios';

var gaEventsHandlerApp = function() {
    var init = function() {
        if ( typeof ga === 'function' ) {
            handleShareClicks();
            handleSubscriptionSubmits();
            handleDonationClicks();

            if ( document.body.classList.contains('thankyou-page') ) {
                const paymentID = new URL(location.href).searchParams.get('PAYMENT_ID');
                const paymentApiUrl = window.location.protocol+'//'+window.location.hostname+'/wp-json/payments/v1/get-payment/';
                const donationTypePaymentApiUrl = window.location.protocol+'//'+window.location.hostname+'/wp-json/payments/v1/get-payment-with-donation-type/';

                if ( paymentID ) {
                    //New GA event for single and monthly success donations
                    axios.post(donationTypePaymentApiUrl, {
                        paymentID: paymentID,
                    })
                    .then((response) => {
                        const paymentData = JSON.parse(response['data']);
                        
                        if (paymentData.amount) {
                            if (paymentData.donation_type) {
                                ga('send', 'event', 'Donation', 'Success', 'Monthly', paymentData.amount);
                            } else {
                                ga('send', 'event', 'Donation', 'Success', 'Single', paymentData.amount);
                            }
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    })

                    // Old GA event donation submit
                    axios.post(paymentApiUrl, {
                            paymentID: paymentID,
                        })
                        .then(function (response) {
                            let donationAmount = response['data'];

                            ga('send', 'event', 'Donation', 'Submit', '', donationAmount );
                        })
                        .catch(function (error) {
                            console.log(error);
                        });    
                }
            }

            if ( document.body.classList.contains('page-template-template-donate') ) {
                let form = document.querySelector('#donation-form');
               
                if ( form ) {

                    //Checker for form submission so we don't send abandonment event when submitting donation
                    form.querySelector('#go-to-payment').addEventListener('click', () => {
                        window.removeEventListener('beforeunload', handleDonationAbandonment);
                    });
                
                    //Before closing document -> send abandon event if form is not submitted
                    window.addEventListener('beforeunload', handleDonationAbandonment);
                }
            }
        }
    }

    /*METHODS
    ##########################################################################################**/

    function handleDonationClicks() {
        if ( document.body.classList.contains('single-post') ) {
            let ctaBtn = document.querySelector( 'section.cta a.button');

            if ( ctaBtn ) {
                ctaBtn.addEventListener('click', (e) => {
                    ga('send', 'event', 'Blog CTA', 'Click button', e.target.baseURI );
                });
            }
        }
    }

     function handleShareClicks() {
        if ( document.querySelector( 'section.cta.share') ) {
            document.querySelectorAll( 'section.cta.share a.share-button').forEach(( el ) => {
                if ( el.classList.contains('fb') ) {
                    el.addEventListener('click', (e) => {
                        ga('send', 'event', 'Facebook share', 'Click share button', e.target.baseURI );
                    });
                } else if ( el.classList.contains('in') ) {
                    el.addEventListener('click', (e) => {
                        ga('send', 'event', 'LinkedIn share', 'Click share button', e.target.baseURI );
                    });
                } else if ( el.classList.contains('tw') ) {
                    el.addEventListener('click', (e) => {
                        ga('send', 'event', 'Twitter share', 'Click share button', e.target.baseURI );
                    });
                }
            });
        }
    }

    function handleSubscriptionSubmits() {
        //Every page should have footer and footer form
        let form = document.querySelector( 'footer .bottom form');

        if ( form ) { 
            form.addEventListener('submit', (e) => {
                ga('send', 'event', 'Footer subscription', 'Submit', e.target.baseURI );
            });
        }
    }

    function handleDonationAbandonment() {
        let inputsString = '';
        let inputFields = document.querySelectorAll('div.input-wrapper input');

        if ( inputFields ) {
            inputFields.forEach((el) => {
                if ( el.getAttribute('name') !== null ) { //only appropriate fields

                    //make a key-value string "key:value;"
                    let currentValueString = el.getAttribute('name') + ':';
                    if ( el.getAttribute('type') !== 'checkbox' ) {
                        if ( el.value !== '' ) {
                            currentValueString += el.value + ';';
                        } else {
                            currentValueString +=  'empty;';
                        }
                    } else if ( el.getAttribute('type') === 'checkbox' ) {
                        if ( el.checked === true ) {
                            currentValueString += 'yes;';
                        } else {
                            currentValueString +=  'no;';
                        }
                    }

                    //append to master string
                    inputsString += currentValueString;
                }
            });
        }

        //Send master string to GA as an event if not empty 
        if ( inputsString ) {
            ga('send', 'event', 'Donation form abandonment', 'Leave page', inputsString );
        }  
    }

    function handleDonationSubmit() {
        let donationAmount = document.querySelector('div.input-wrapper div.amount-wrapper button.active').dataset.amount
                            ? document.querySelector('div.input-wrapper div.amount-wrapper button.active').dataset.amount
                            : document.querySelector('div.input-wrapper div.amount-wrapper input[name="amount"]').value ;

        if ( donationAmount !== '' || donationAmount !== null ) {
            ga('send', 'event', 'Donation', 'Submit', '', donationAmount );
        }
    }

    return { init: init }
}();

export default gaEventsHandlerApp;


